// @ts-check

// Client lib imports
const airbrake = require('client/lib/airbrake')

/** @typedef { import('redux').Store } ReduxStore */

module.exports = hydrateStore

/**
 * @param {(options: { state: any }) => ReduxStore} configureStore
 * @returns {ReduxStore}
 */
function hydrateStore(configureStore) {
  const deserializedState = deserializePreloadedState()
  const store = configureStore({ state: deserializedState })

  // Investigating TypeError: Cannot read property 'buildNumber' of null
  // https://app.asana.com/0/102902769366319/682087171396667/f
  const reifiedState = store.getState()
  if (deserializedState && deserializedState.env && !reifiedState.env) {
    airbrake.notify({
      error: new Error('Redux preloaded state reified as empty'),
      params: {
        deserializedState,
        documentBody: document.body.innerHTML,
        reifiedState: typeof reifiedState.toJS === 'function'
          ? reifiedState.toJS()
          : reifiedState
      }
    })
  }

  return store
}

function deserializePreloadedState() {
  const stateElement = document.getElementById('preloaded-state')
  if (stateElement) {
    const serializedState = stateElement.textContent
    try {
      const deserializedState = JSON.parse(serializedState)
      // Investigating TypeError: Cannot read property 'buildNumber' of null
      // https://app.asana.com/0/102902769366319/682087171396667/f
      if (!deserializedState || !deserializedState.env) {
        airbrake.notify({
          error: new Error('Redux preloaded state deserialized as empty'),
          params: {
            deserializedState,
            serializedState,
            documentBody: document.body.innerHTML
          }
        })
      }
      return deserializedState
    } catch (err) {
      // Investigating TypeError: Cannot read property 'buildNumber' of null
      // https://app.asana.com/0/102902769366319/682087171396667/f
      airbrake.notify({
        error: err,
        params: {
          serializedState
        }
      })
    }
  } else {
    // Investigating TypeError: Cannot read property 'buildNumber' of null
    // https://app.asana.com/0/102902769366319/682087171396667/f
    airbrake.notify({
      error: new Error('Redux preloaded state is undefined'),
      params: {
        documentBody: document.body.innerHTML
      }
    })
  }
}
